import axios from "axios";

const BASE = process.env.REACT_APP_BASE_URL;

export const fetchPublicMediaImagesByUse = async (imageUse) => {
  try {
    const res = await axios.get(`${BASE}/public/media-images/use/${imageUse}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [] };
  }
};
